import WrappedPicker from '../WrappedPicker';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { workflowStudies } from '../../content/thWorkflowStudies';
import '../../styles/workflow-studies.css';
import WorkflowSystems from './WorkflowSystems';
import { workflowStudies as englishStudies } from '../../content/workflowStudies';

const functions = [...new Set(workflowStudies.map(study => study.function))];

export default function CaseStudyCarousel() {
  const [industry, setIndustry] = useState('ทุกอุตสาหกรรม');
  const [businessFunction, setBusinessFunction] = useState('งานทุกประเภท');
  const [query, setQuery] = useState('');
  const [expanded, setExpanded] = useState<string | null>(null);
  const [detailView, setDetailView] = useState('ภาพรวม');
  const [showAll, setShowAll] = useState(false);
  const filtered = workflowStudies.filter(study =>
    (industry === 'ทุกอุตสาหกรรม' || study.industry === industry) &&
    (businessFunction === 'งานทุกประเภท' || study.function === businessFunction) &&
    Object.values(study).flat().join(' ').toLowerCase().includes(query.trim().toLowerCase())
  );
  const visible = showAll ? filtered : filtered.slice(0, 6);
  const reset = () => { setIndustry('ทุกอุตสาหกรรม'); setBusinessFunction('งานทุกประเภท'); setQuery(''); setShowAll(false); };

  return (
    <section id="case-studies" className="workflow-studies" aria-labelledby="workflows-heading">
      <div className="ws-shell">
        <div className="ws-heading">
          <div>
            <p className="ws-kicker">ตัวอย่างเวิร์กโฟลว์</p>
            <h2 id="workflows-heading">ค้นหาเวิร์กโฟลว์ที่เหมาะกับธุรกิจคุณ</h2>
          </div>
          <div className="ws-intro">
            <p>ค้นหาปัญหาที่คุณคุ้นเคย เปิดตัวอย่างเพื่อดูแนวทางแก้ ระบบที่เกี่ยวข้อง และผลที่ตั้งใจให้เกิด</p>
            <p className="ws-evidence">ดูตัวอย่างเวิร์กโฟลว์ 18 แบบ แต่ละแบบเป็นแนวทางที่เสนอ ไม่ใช่คำกล่าวอ้างถึงผลงานลูกค้าที่เสร็จแล้ว</p>
          </div>
        </div>

        <div className="ws-finder">
          <div className="ws-inputs">
            <WrappedPicker label="เลือกอุตสาหกรรม" value={industry} onChange={value => { setIndustry(value); setShowAll(false); }} choices={['ทุกอุตสาหกรรม', ...workflowStudies.map(study => study.industry)].map(name => ({ id: name, name }))} />
            <WrappedPicker label="ประเภทงาน" value={businessFunction} onChange={value => { setBusinessFunction(value); setShowAll(false); }} choices={['งานทุกประเภท', ...functions].map(name => ({ id: name, name }))} />
            <label>หรือค้นหาปัญหา
              <input type="search" value={query} onChange={event => { setQuery(event.target.value); setShowAll(false); }} placeholder="ลองค้นหา ใบแจ้งหนี้ สต็อก การเริ่มงาน..." />
            </label>
          </div>

        </div>

        <div className="ws-results-header">
          <p role="status">{filtered.length === 0 ? 'ไม่พบตัวอย่างที่ตรงกัน' : `${filtered.length} ${filtered.length === 1 ? 'ตัวอย่าง' : 'ตัวอย่าง'}${visible.length < filtered.length ? ` · แสดง ${visible.length}` : ''}`}</p>
          {(industry !== 'ทุกอุตสาหกรรม' || businessFunction !== 'งานทุกประเภท' || query) && <button type="button" onClick={reset}>ล้างตัวกรอง</button>}
        </div>

        <div className="ws-results">
          {visible.map(study => {
            const isOpen = expanded === study.id;
            return <article className={`ws-study${isOpen ? ' is-open' : ''}`} key={study.id}>
              <h3><button className="ws-study-toggle" type="button" aria-expanded={isOpen} aria-controls={`study-${study.id}`} onClick={() => { setExpanded(isOpen ? null : study.id); setDetailView('ภาพรวม'); }}>
                <span className="ws-industry">{study.industry}<span>{study.function}</span></span>
                <span className="ws-title">{study.title}</span>
                <span className="ws-toggle-mark">{isOpen ? 'ปิดตัวอย่าง' : 'ดูตัวอย่าง'} <span aria-hidden="true">{isOpen ? '−' : '+'}</span></span>
              </button></h3>
              {isOpen && <div id={`study-${study.id}`} className="ws-detail">
                <div className="ws-detail-nav" role="group" aria-label={`ส่วนต่าง ๆ ของตัวอย่าง ${study.industry}`}>
                  {['ภาพรวม', 'เวิร์กโฟลว์', 'ผลที่คาดหวัง'].map(view => <button key={view} type="button" aria-pressed={detailView === view} aria-controls={`study-content-${study.id}`} onClick={() => setDetailView(view)}>{view}</button>)}
                </div>
                <div className="ws-detail-layout">
                  <div id={`study-content-${study.id}`} className="ws-reading">
                    {detailView === 'ภาพรวม' && <>
                      <div className="ws-problem"><h4>ปัญหา</h4><p>{study.situation}</p></div>
                      <div className="ws-outcome"><h4>ผลลัพธ์ที่ตั้งใจ</h4><p>{study.outcome}</p></div>
                      <button className="ws-next" type="button" onClick={() => setDetailView('เวิร์กโฟลว์')}>ดูวิธีทำงานของเวิร์กโฟลว์ <span aria-hidden="true">→</span></button>
                    </>}
                    {detailView === 'เวิร์กโฟลว์' && <div className="ws-solution"><h4>แนวทางแก้ปัญหา</h4><ol>{study.steps.map((step, index) => <li key={step}><span aria-hidden="true">{index + 1}</span><p>{step}</p></li>)}</ol><div className="ws-control"><h4>คนยังเป็นผู้ควบคุม</h4><p>{study.control}</p></div></div>}
                    {detailView === 'ผลที่คาดหวัง' && <><div className="ws-outcome"><h4>ผลลัพธ์ที่ตั้งใจ</h4><p>{study.outcome}</p></div><div className="ws-measures"><h4>วิธีวัดความสำเร็จ</h4><ul>{study.measures.map(measure => <li key={measure}>{measure}</li>)}</ul><p>กำหนดค่าตั้งต้นก่อนเริ่ม แล้วเปรียบเทียบตัวชี้วัดเดิมหลังเปิดใช้</p></div></>}
                  </div>
                  <WorkflowSystems systems={study.systems} iconSystems={englishStudies.find(item => item.id === study.id)!.systems} />
                </div>
                <div className="ws-detail-footer"><p>เริ่มจากทีมเดียวและเวิร์กโฟลว์เดียว</p><Link to="/th/#request-demo">คุยเรื่องเวิร์กโฟลว์นี้ <span aria-hidden="true">↗</span></Link></div>
              </div>}
            </article>;
          })}
        </div>
        {filtered.length === 0 && <div className="ws-empty"><h3>ไม่พบตัวอย่างที่ตรงกัน? ขั้นตอนส่งต่องานอาจคล้ายกัน</h3><p>ลองคำค้นที่กว้างขึ้น ล้างตัวกรอง หรือเล่ากระบวนการที่ทีมกำลังเจอให้เราฟัง</p><button type="button" onClick={reset}>ดูตัวอย่างทั้งหมด</button></div>}
        {filtered.length > 6 && <button className="ws-more" type="button" onClick={() => { setShowAll(!showAll); if (showAll) setExpanded(null); }}>{showAll ? 'แสดงตัวอย่างน้อยลง' : `ดูทั้งหมด ${filtered.length} ตัวอย่าง`} <span aria-hidden="true">{showAll ? '−' : '+'}</span></button>}

        <div className="ws-bottom"><div><h3>ไม่พบกระบวนการของคุณที่นี่?</h3><p>เล่างานที่ทีมต้องคอยติดตาม เราช่วยประเมินได้ว่างานนั้นเหมาะกับระบบอัตโนมัติหรือไม่</p></div><Link to="/th/#request-demo">มาวางขั้นตอนงานของคุณกัน <span aria-hidden="true">↗</span></Link></div>
      </div>
    </section>
  );
}
